import React, { useState } from 'react';
import { Grid, IconButton, InputAdornment, TextField } from '@material-ui/core';
import AddIcon from '@mui/icons-material/Add';
import { css } from '@emotion/react';
import { colors } from '@/styles';
import { PrimaryButton } from '@/styles/blocks';
import ZipList from '../ZipList';

const parseZipInput = (raw) =>
    raw
        .split(/[\s,]+/)
        .map((z) => z.trim())
        .filter(Boolean);

const ZipsColumn = ({ state, loading, callbacks, onOpenSubregionDetails }) => {
    const [zipInput, setZipInput] = useState('');

    if (!state.selectedSubregion) return null;

    const handleAddZips = () => {
        const zips = parseZipInput(zipInput);
        if (zips.length === 0) return;

        const invalid = zips.filter((z) => !/^\d{5}$/.test(z));
        if (invalid.length) {
            callbacks.setNotification({
                severity: 'error',
                message: `Invalid zip code${invalid.length > 1 ? 's' : ''}: ${invalid.join(', ')}`,
            });
            return;
        }

        const subregion_id = state.selectedSubregion.subregion_id;
        const existing = new Set((state.selectedSubregion.zips || []).map((m) => m.zip));
        const fresh = Array.from(new Set(zips)).filter((z) => !existing.has(z));
        if (fresh.length === 0) {
            callbacks.setNotification({
                severity: 'info',
                message: 'All entered zip codes are already in this subregion.',
            });
            setZipInput('');
            return;
        }

        callbacks.addZips(fresh.map((zip) => ({ subregion_id, zip })));
        setZipInput('');
    };

    return (
        <Grid
            container
            direction="column"
            css={css`
                flex: 0;
                flex-basis: 0;
                min-width: 320px;
                flex-wrap: nowrap;
                border-right: 1px solid ${colors.greys[0]};
            `}
        >
            <Grid
                item
                css={css`
                    padding: 12px 20px 0px 20px;
                `}
            >
                <PrimaryButton
                    fullWidth
                    onClick={onOpenSubregionDetails}
                    css={css`
                        height: 40px;
                    `}
                >
                    Subregion Details
                </PrimaryButton>
            </Grid>
            <Grid
                item
                css={css`
                    padding: 12px 20px 0px 20px;
                `}
            >
                <TextField
                    fullWidth
                    size="small"
                    variant="outlined"
                    label="Add Zip Codes"
                    placeholder="e.g. 90210, 10001"
                    value={zipInput}
                    onChange={(e) => setZipInput(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            handleAddZips();
                        }
                    }}
                    disabled={loading?.zips}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton
                                    size="small"
                                    onClick={handleAddZips}
                                    disabled={!zipInput.trim() || loading?.zips}
                                    aria-label="add zips"
                                >
                                    <AddIcon fontSize="small" />
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />
            </Grid>
            <ZipList
                options={{}}
                loading={loading}
                filter={state.filter}
                subregion={state.selectedSubregion}
                zips={state.selectedSubregion.zips}
                callbacks={callbacks}
            />
        </Grid>
    );
};

export default ZipsColumn;
